<template>
  <ZmBanner v-bind="otherAttrs" v-on="eventHandlers" ref="zmBanner" :type="computedType" :content="computedContent">
    <template v-for="(slotFn, name) in slots" #[name]="slotProps" :key="name">
      <component :is="slotFn" v-bind="slotProps" />
    </template>
  </ZmBanner>
</template>

<script setup>
import { onMounted, nextTick, useAttrs, useSlots, computed, ref } from 'vue';
import { omit } from 'lodash';
import { ZmBanner } from '@zoom/zoom-ui-vue3';

import { EVENT_TYPES, emit } from '@/utils/event-emitter.js';

defineOptions({ inheritAttrs: false });

const zmBanner = ref(null);

const attrs = useAttrs();
const slots = useSlots();

const computedType = computed(() => {
  const type = attrs.type;
  return type === 'error' ? 'danger' : type;
});

const computedContent = computed(() => {
  return attrs.content || attrs.description || '';
});

const otherAttrs = computed(() => {
  const filteredAttrs = omit(attrs, ['type', 'content', 'description']);
  // Map closable to show-close for Vue3 compatibility
  if ('closable' in attrs) {
    filteredAttrs['show-close'] = attrs.closable;
    delete filteredAttrs.closable;
  }
  return filteredAttrs;
});

const eventHandlers = computed(() => {
  // Only pass real event handlers, filter out non-event attributes
  const events = {};
  Object.keys(attrs).forEach(key => {
    // Check if it's an event handler starting with 'on'
    if (key.startsWith('on') && typeof attrs[key] === 'function') {
      events[key] = attrs[key];
    }
  });
  return events;
});

onMounted(async () => {
  setTimeout(async () => {
  await nextTick();
  const defaultSlotEl = zmBanner.value?.$el?.querySelector('.zbo-banner__content');
  const fallbackMessage = (!attrs.content && !attrs.description && defaultSlotEl) ? defaultSlotEl.textContent : '';
  const title = attrs.title;
  const description = attrs.description;

  emit(EVENT_TYPES.UI_ALERT, {
    type: attrs.type,
    message: [title, description, fallbackMessage].filter(Boolean),
  });
  }, 1000); // payment error pop up one by one
});
</script>
